var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChademo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.c{fill:#c8d1ec;}.d,.f{fill:#fff;}.e,.f{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335 -577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    transform: "translate(351 593)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(375 607.031)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7 13 C 3.691590070724487 13 1 10.30840969085693 1 7 C 1 3.691590070724487 3.691590070724487 1 7 1 C 10.30840969085693 1 13 3.691590070724487 13 7 C 13 10.30840969085693 10.30840969085693 13 7 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 7 2 C 4.242989540100098 2 2 4.242989540100098 2 7 C 2 9.757009506225586 4.242989540100098 12 7 12 C 9.757009506225586 12 12 9.757009506225586 12 7 C 12 4.242989540100098 9.757009506225586 2 7 2 M 7 0 C 10.86598968505859 0 14 3.134010314941406 14 7 C 14 10.86598968505859 10.86598968505859 14 7 14 C 3.134010314941406 14 0 10.86598968505859 0 7 C 0 3.134010314941406 3.134010314941406 0 7 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(367 598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(367 620)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(355 607.031)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7 13 C 3.691590070724487 13 1 10.30840969085693 1 7 C 1 3.691590070724487 3.691590070724487 1 7 1 C 10.30840969085693 1 13 3.691590070724487 13 7 C 13 10.30840969085693 10.30840969085693 13 7 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 7 2 C 4.242989540100098 2 2 4.242989540100098 2 7 C 2 9.757009506225586 4.242989540100098 12 7 12 C 9.757009506225586 12 12 9.757009506225586 12 7 C 12 4.242989540100098 9.757009506225586 2 7 2 M 7 0 C 10.86598968505859 0 14 3.134010314941406 14 7 C 14 10.86598968505859 10.86598968505859 14 7 14 C 3.134010314941406 14 0 10.86598968505859 0 7 C 0 3.134010314941406 3.134010314941406 0 7 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(371 602)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 1 0 C 1.552289962768555 0 2 0.4477200508117676 2 1 C 2 1.552289962768555 1.552289962768555 2 1 2 C 0.4477200508117676 2 0 1.552289962768555 0 1 C 0 0.4477200508117676 0.4477200508117676 0 1 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(371 624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 1 0 C 1.552289962768555 0 2 0.4477200508117676 2 1 C 2 1.552289962768555 1.552289962768555 2 1 2 C 0.4477200508117676 2 0 1.552289962768555 0 1 C 0 0.4477200508117676 0.4477200508117676 0 1 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChademo);
export default __webpack_public_path__ + "static/media/chademo.f522a1445f49ec01ea2bb11205bc8f3f.svg";
export { ForwardRef as ReactComponent };